import { SearchOutlined } from '@ant-design/icons';
import { Button, Form, Select, Switch } from 'antd';
import React from 'react';
// @ts-ignore
import { connect } from 'react-redux';
import {
  setBackgroundType,
  setColoredField,
  setLinkVisiblity,
  setViewType,
  zoomToFit,
} from '../../actions/graph-modals';
import { backgroundTypes, viewTypes } from '../../reducers/graph-modals';
import { getColorsForField, nodesInfoSorter } from '../../utils/helpers';
import { ColoredField, Dispatch, store } from '../../utils/types';

const { Option } = Select;

const ViewOptions = ({
  areLinksVisible,
  setAreLinksVisible,
  zoomToFitAction,
  viewType,
  setViewTypeAction,
  backgroundType,
  setBackgroundTypeAction,
  coloredField,
  setColoredFieldAction,
  queryResponse,
}: any) => {
  return (
    <>
      <div className="flex flex-col space-y-4">
        <div className="">
          <Form.Item labelCol={{ span: 24 }} label="View Type">
            <Select
              value={viewType}
              onChange={setViewTypeAction}
              placeholder="Select"
              className="w-full rounded-select"
            >
              {viewTypes.map((o: string, i: any) => (
                <Option key={i} value={o}>
                  {o}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {viewType === viewTypes[0] && (
            <div className="flex flex-col space-y-4 pl-4">
              <div className="flex justify-between">
                <span className="mr-2">Show Links </span>
                <div>
                  <Switch
                    size="small"
                    checked={areLinksVisible}
                    onChange={(checked: boolean) => setAreLinksVisible(checked)}
                  />
                </div>
              </div>
              <div className="flex justify-between  ">
                <span className="mr-2">Zoom to fit </span>
                <div>
                  <Button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon={<SearchOutlined />}
                    onClick={() => zoomToFitAction()}
                  />
                </div>
              </div>
              <Form.Item labelCol={{ span: 24 }} label="Background">
                <Select
                  value={backgroundType}
                  onChange={setBackgroundTypeAction}
                  placeholder="Select"
                  className="w-full rounded-select"
                >
                  {backgroundTypes.map((o: string, i: any) => (
                    <Option key={i} value={o}>
                      {o}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          )}
        </div>

        <div>
          <Form.Item labelCol={{ span: 24 }} label="Color by">
            <Select
              value={coloredField?.key}
              onChange={(value) => {
                setColoredFieldAction({
                  key: value,
                  colors: getColorsForField(queryResponse?.nodesInfo, value),
                });
              }}
              placeholder="Select"
              className="w-full rounded-select"
            >
              {queryResponse?.nodesInfo &&
                Object.keys(queryResponse?.nodesInfo)
                  .sort(nodesInfoSorter)
                  .map((o: string, i: any) => (
                    <Option key={i} value={o}>
                      {o}
                    </Option>
                  ))}
            </Select>
          </Form.Item>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: store) => ({
  areLinksVisible: state.graphModals.areLinksVisible,
  viewType: state.graphModals.viewType,
  backgroundType: state.graphModals.backgroundType,
  coloredField: state.graphModals.coloredField,
  queryResponse: state.query.queryResponse,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setAreLinksVisible: (visible: boolean) => dispatch(setLinkVisiblity(visible)),
  zoomToFitAction: () => {
    dispatch(zoomToFit());
  },
  setViewTypeAction: (viewType: string) => dispatch(setViewType(viewType)),
  setBackgroundTypeAction: (backgroundType: string) =>
    dispatch(setBackgroundType(backgroundType)),
  setColoredFieldAction: (coloredField?: ColoredField) =>
    dispatch(setColoredField(coloredField)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ViewOptions);
